export default {
    error: require('./error.svg')
};